import { CardProductGallery } from './card-product-gallery/card-product-gallery';
import { productLike } from '@/shared/product-like/product-like';
import { addToCart } from '@/shared/add-to-cart/add-to-cart';
import { DiscountTimer } from '@/shared/discount-timer/discount-timer';

export class CardProduct {
	constructor($card, options = {}) {
		this.$card = $card;
		this.options = options;

		this.init();
	}

	init() {
		this.initGallery();
		productLike(this.$card, '.card-product__fav-button');
		addToCart(this.$card, '.card-product__add-to-cart');
		this.initDiscountTimer();
	}

	initGallery() {
		const galleryEl = this.$card.querySelector('.js-card-product-gallery');
		if (!galleryEl) return;

		this.gallery = new CardProductGallery(galleryEl, this.options.gallery);
	}

	initDiscountTimer() {
		const timer = this.$card.querySelector('.js-discount-timer');
		if (!timer) return;

		this.discountTimer = new DiscountTimer(timer, this.options.discountTimer);
		timer.addEventListener('timerComplete', this.handleDiscountTimerEnd);
	}

	handleDiscountTimerEnd = () => {
		this.$card.querySelector('.card-product__timer')?.remove();
		this.$card.querySelector('.card-product__discount-label')?.remove();
	};
}
